import { render } from "../utils/template";
import { get } from "jquery";
import debounce from "lodash/debounce";

export function SearchBox(element, container) {
  const containers = document.querySelectorAll(container);
  const DEBOUNCE_TIME = 500;
  const DISABLED_CLASS = "is-disabled";
  const loader = document.querySelector(element.dataset.loader);
  const form = formFind(element);

  function formFind(element) {
    parent = element.parentNode;
    if (parent.nodeName != "FORM") {
      formFind(parent);
    }
    return parent;
  }

  function handleLoading(status = "start") {
    if (status == "start") {
      form.classList.add(DISABLED_CLASS);
      loader.classList.add("is-active");
    } else {
      form.classList.remove(DISABLED_CLASS);
      loader.classList.remove("is-active");
    }
  }

  function getResults(query, context) {
    handleLoading();
    get(
      teik.ajax_url,
      {
        action: "custom_search",
        search: query,
        context
      },
      res => {
        let html = "";
        res.forEach(item => {
          html += render("search-result-template", item);
        });
        _updateContainers(html);
        handleLoading("finished");
      }
    );
  }

  function _updateContainers(template) {
    containers.forEach(element => {
      element.innerHTML = template;
    });
  }
  const deboundedSearch = debounce((value, context) => {
    getResults(value, context);
  }, DEBOUNCE_TIME);

  function handleChange(e) {
    if (e.key !== " ") {
      const contextInput = form.querySelector(".context-input");
      let context = "";
      if (contextInput) {
        context = contextInput.value;
      }
      deboundedSearch(e.target.value, context);
    }
  }

  element.addEventListener("keyup", handleChange);
}
